import { useDetailRecord } from "@taunggyi-plus/auth";
import { RecordFormDialog } from "@taunggyi-plus/design-system";
import { RecordTable } from "@taunggyi-plus/design-system";
import { formatRecordDate } from "@taunggyi-plus/design-system";
import { submitOrderRequest } from "@taunggyi-plus/api-client";
import { useOrderRefresh } from "@taunggyi-plus/auth";
import { SignOutButton, useFeedback } from "@taunggyi-plus/auth";
import { CountStrip, ProviderReputation } from "@taunggyi-plus/finance-feature";
import { useCallback, useEffect, useMemo, useRef, useState, type FormEvent } from "react";
import { useAuth } from "@taunggyi-plus/auth";
import {
  Card,
  ManagementListToolbar,
  PaginatedList,
  StatusPill,
} from "@taunggyi-plus/design-system";
import type { Locale } from "@taunggyi-plus/domain";

const copy = {
  en: {
    hotelBooking: "Link Stay booking",
    findStay: "Find a stay in Taunggyi",
    freeRequest: "Send a free request now. Pay the hotel after it confirms availability.",
    chooseHotel: "Link Stay in Taunggyi",
    hotelDirectoryHelp: "Choose a hotel to view rooms, details, and booking options.",
    from: "From",
    viewHotel: "View hotel",
    closeHotel: "Close hotel details",
    bookNow: "Book this room",
    closeLogin: "Close sign in",
    cashHotel: "Cash at hotel",
    request: "Request",
    noCharge: "No charge now. The hotel must confirm your request.",
    checkIn: "Check-in",
    checkOut: "Check-out",
    rooms: "Rooms",
    guests: "Guests",
    guestName: "Guest name",
    phone: "Phone",
    note: "Note (optional)",
    send: "Send booking request",
    sending: "Sending…",
    secure: "Secure account",
    create: "Create your account",
    signIn: "Sign in to continue",
    historyHelp: "Your booking history stays connected to your verified email.",
    name: "Name",
    email: "Email",
    password: "Password",
    wait: "Please wait…",
    createButton: "Create account",
    newHere: "New here? Create an account",
    already: "Already have an account? Sign in",
    signOut: "Sign out",
    signedIn: "Signed in as",
    checking: "Checking your secure session…",
    signInFirst: "Sign in before sending a booking request.",
    sent: "Request sent. The hotel will confirm availability and contact you.",
    upTo: "up to",
    myBookings: "My booking requests",
    noBookings: "You have no booking requests yet.",
    operations: "Booking operations",
    decisions: "Requests needing a decision",
    confirmAdvice: "Confirm only after checking room availability. Every response is recorded.",
    confirm: "Confirm",
    reject: "Reject",
    noRequests: "No booking requests yet",
    approvalHelp: "New requests will appear here after your hotel account is approved.",
    pending: "Pending",
    confirmed: "Confirmed",
    rejected: "Rejected",
    cancelled: "Cancelled",
    cancelBooking: "Cancel request",
    cancellationSaved: "Booking request cancelled. The hotel was notified.",
    responseSaved: "Response saved. The customer notification was created.",
    accountCreated: "Account created. Check your email to verify it.",
    signedInDone: "Signed in.",
    roomWord: "room(s)",
    noteLabel: "Note",
  },
  my: {
    hotelBooking: "Link Stay ဘွတ်ကင်",
    findStay: "တောင်ကြီးတွင် တည်းခိုရန် ရှာပါ",
    freeRequest: "အခမဲ့ တောင်းဆိုပါ။ ဟိုတယ်အတည်ပြုပြီးမှ ဟိုတယ်တွင် ငွေပေးချေပါ။",
    chooseHotel: "တောင်ကြီးရှိ Link Stay",
    hotelDirectoryHelp: "အခန်း၊ အသေးစိတ်နှင့် ဘွတ်ကင်ရွေးချယ်မှုများကြည့်ရန် ဟိုတယ်တစ်ခုရွေးပါ။",
    from: "စတင်ဈေး",
    viewHotel: "ဟိုတယ်ကြည့်ရန်",
    closeHotel: "ဟိုတယ်အသေးစိတ် ပိတ်မည်",
    bookNow: "ဤအခန်းကို ဘွတ်ကင်လုပ်မည်",
    closeLogin: "အကောင့်ဝင်ခြင်း ပိတ်မည်",
    cashHotel: "ဟိုတယ်တွင် ငွေပေးချေမည်",
    request: "တောင်းဆိုရန်",
    noCharge: "ယခု ငွေပေးရန်မလိုပါ။ ဟိုတယ်မှ အတည်ပြုရပါမည်။",
    checkIn: "တည်းခိုမည့်ရက်",
    checkOut: "ထွက်ခွာမည့်ရက်",
    rooms: "အခန်း",
    guests: "ဧည့်သည်",
    guestName: "ဧည့်သည်အမည်",
    phone: "ဖုန်း",
    note: "မှတ်ချက် (မဖြစ်မနေမဟုတ်)",
    send: "ဘွတ်ကင်တောင်းဆိုချက် ပို့မည်",
    sending: "ပို့နေသည်…",
    secure: "လုံခြုံသောအကောင့်",
    create: "အကောင့်ဖွင့်ပါ",
    signIn: "ဆက်လက်ရန် အကောင့်ဝင်ပါ",
    historyHelp: "သင့်ဘွတ်ကင်မှတ်တမ်းကို အတည်ပြုထားသော အီးမေးလ်ဖြင့် သိမ်းဆည်းထားမည်။",
    name: "အမည်",
    email: "အီးမေးလ်",
    password: "စကားဝှက်",
    wait: "ခဏစောင့်ပါ…",
    createButton: "အကောင့်ဖွင့်မည်",
    newHere: "အကောင့်မရှိသေးပါသလား။ ဖွင့်ရန်",
    already: "အကောင့်ရှိပြီးပြီလား။ ဝင်ရန်",
    signOut: "ထွက်မည်",
    signedIn: "ဝင်ထားသောအကောင့်",
    checking: "လုံခြုံသော session ကို စစ်ဆေးနေသည်…",
    signInFirst: "ဘွတ်ကင်မပို့မီ အကောင့်ဝင်ပါ။",
    sent: "တောင်းဆိုချက်ပို့ပြီးပါပြီ။ ဟိုတယ်မှ အတည်ပြုပြီး ဆက်သွယ်ပါမည်။",
    upTo: "အများဆုံး",
    myBookings: "ကျွန်ုပ်၏ ဘွတ်ကင်တောင်းဆိုချက်များ",
    noBookings: "ဘွတ်ကင်တောင်းဆိုချက် မရှိသေးပါ။",
    operations: "ဘွတ်ကင်စီမံခန့်ခွဲမှု",
    decisions: "ဆုံးဖြတ်ရန်လိုသော တောင်းဆိုချက်များ",
    confirmAdvice:
      "အခန်းလွတ်ရှိကြောင်း စစ်ဆေးပြီးမှ အတည်ပြုပါ။ လုပ်ဆောင်ချက်တိုင်း မှတ်တမ်းတင်ထားမည်။",
    confirm: "အတည်ပြုမည်",
    reject: "ငြင်းပယ်မည်",
    noRequests: "တောင်းဆိုချက် မရှိသေးပါ",
    approvalHelp: "ဟိုတယ်အကောင့် အတည်ပြုပြီးပါက တောင်းဆိုချက်အသစ်များ ဤနေရာတွင် ပေါ်လာမည်။",
    pending: "စောင့်ဆိုင်းဆဲ",
    confirmed: "အတည်ပြုပြီး",
    rejected: "ငြင်းပယ်ပြီး",
    cancelled: "ပယ်ဖျက်ပြီး",
    cancelBooking: "တောင်းဆိုချက် ပယ်ဖျက်မည်",
    cancellationSaved: "ဘွတ်ကင်တောင်းဆိုချက် ပယ်ဖျက်ပြီး ဟိုတယ်ကို အသိပေးပြီးပါပြီ။",
    responseSaved: "အဖြေကို သိမ်းပြီး ဖောက်သည်ထံ အသိပေးချက် ဖန်တီးပြီးပါပြီ။",
    accountCreated: "အကောင့်ဖွင့်ပြီးပါပြီ။ အီးမေးလ်ကို စစ်ဆေးပြီး အတည်ပြုပါ။",
    signedInDone: "အကောင့်ဝင်ပြီးပါပြီ။",
    roomWord: "ခန်း",
    noteLabel: "မှတ်ချက်",
  },
  shn: {
    hotelBooking: "ၸွင်း Link Stay",
    findStay: "ႁႃႁူင်းလိုဝ်ႈသဝ်းၼႂ်းဝဵင်းတူၼ်ႈတီး",
    freeRequest: "သူင်ႇၶေႃႈယွၼ်းလၢႆလၢႆ။ ပၼ်ငိုၼ်းတီႈႁူင်းလိုဝ်ႈသဝ်း ဝၢႆးမၼ်းယိုၼ်ယၼ်။",
    chooseHotel: "Link Stay ၼႂ်းတူၼ်ႈတီး",
    hotelDirectoryHelp: "လိူၵ်ႈႁူင်းလိုဝ်ႈသဝ်းတႃႇတူၺ်းႁွင်ႈ၊ ၶေႃႈမုၼ်းလႄႈၸွင်း။",
    from: "တႄႇတီႈ",
    viewHotel: "တူၺ်းႁူင်းလိုဝ်ႈသဝ်း",
    closeHotel: "ပိၵ်ႉၶေႃႈမုၼ်းႁူင်းလိုဝ်ႈသဝ်း",
    bookNow: "ၸွင်းႁွင်ႈၼႆႉ",
    closeLogin: "ပိၵ်ႉၵၢၼ်ၶဝ်ႈဢၶွင်ႉ",
    cashHotel: "ပၼ်ငိုၼ်းတီႈႁူင်းလိုဝ်ႈသဝ်း",
    request: "ယွၼ်းၸွင်း",
    noCharge: "ယင်းပႆႇလူဝ်ႇပၼ်ငိုၼ်း။ ႁူင်းလိုဝ်ႈသဝ်းတေလႆႈယိုၼ်ယၼ်။",
    checkIn: "ဝၼ်းၶဝ်ႈလိုဝ်ႈ",
    checkOut: "ဝၼ်းဢွၵ်ႇ",
    rooms: "ႁွင်ႈ",
    guests: "ၶႅၵ်ႇ",
    guestName: "ၸိုဝ်ႈၶႅၵ်ႇ",
    phone: "ၾူၼ်း",
    note: "မၢႆတွင်း",
    send: "သူင်ႇၶေႃႈယွၼ်း",
    sending: "တိုၵ်ႉသူင်ႇ…",
    secure: "ဢၶွင်ႉႁူမ်ႇလူမ်ႈ",
    create: "သၢင်ႈဢၶွင်ႉ",
    signIn: "ၶဝ်ႈဢၶွင်ႉတႃႇသိုပ်ႇ",
    historyHelp: "ပိုၼ်းၸွင်းတေၵပ်းဝႆႉတင်းဢီးမေးလ်။",
    name: "ၸိုဝ်ႈ",
    email: "ဢီးမေးလ်",
    password: "မၢႆလပ်ႉ",
    wait: "ပႂ်ႉၵမ်းၼိုင်ႈ…",
    createButton: "သၢင်ႈဢၶွင်ႉ",
    newHere: "ပႆႇမီးဢၶွင်ႉ? သၢင်ႈဢၶွင်ႉ",
    already: "မီးဢၶွင်ႉယဝ်ႉ? ၶဝ်ႈဢၶွင်ႉ",
    signOut: "ဢွၵ်ႇဢၶွင်ႉ",
    signedIn: "ၶဝ်ႈဝႆႉတင်း",
    checking: "တိုၵ်ႉၵူတ်ႇထတ်း session…",
    signInFirst: "ၶဝ်ႈဢၶွင်ႉၵွၼ်ႇသူင်ႇၶေႃႈယွၼ်း။",
    sent: "သူင်ႇၶေႃႈယွၼ်းယဝ်ႉ။ ႁူင်းလိုဝ်ႈသဝ်းတေယိုၼ်ယၼ်လႄႈၵပ်းသိုပ်ႇ။",
    upTo: "တေႃႇထိုင်",
    myBookings: "ၶေႃႈယွၼ်းၸွင်းၶွင်ၶႃႈ",
    noBookings: "ပႆႇမီးၶေႃႈယွၼ်းၸွင်း။",
    operations: "ၸတ်းၵၢၼ်ၵၢၼ်ၸွင်း",
    decisions: "ၶေႃႈယွၼ်းဢၼ်လူဝ်ႇတႅပ်းတတ်း",
    confirmAdvice: "ၵူတ်ႇထတ်းႁွင်ႈဝ่างၵွၼ်ႇယိုၼ်ယၼ်။",
    confirm: "ယိုၼ်ယၼ်",
    reject: "ပၢၵ်ႈပႅတ်ႈ",
    noRequests: "ပႆႇမီးၶေႃႈယွၼ်း",
    approvalHelp: "ၶေႃႈယွၼ်းမႂ်ႇတေဢွၵ်ႇမႃးတီႈၼႆႈ။",
    pending: "တိုၵ်ႉပႂ်ႉ",
    confirmed: "ယိုၼ်ယၼ်ယဝ်ႉ",
    rejected: "ပၢၵ်ႈပႅတ်ႈယဝ်ႉ",
    cancelled: "ယႃႉယဝ်ႉ",
    cancelBooking: "ယႃႉၶေႃႈယွၼ်း",
    cancellationSaved: "ယႃႉၶေႃႈယွၼ်းၸွင်းလႄႈပၼ်ၶၢဝ်ႇႁူင်းလိုဝ်ႈသဝ်းယဝ်ႉ။",
    responseSaved: "သိမ်းၶေႃႈတွပ်ႇလႄႈသူင်ႇၶၢဝ်ႇယဝ်ႉ။",
    accountCreated: "သၢင်ႈဢၶွင်ႉယဝ်ႉ။ ၵူတ်ႇထတ်းဢီးမေးလ်။",
    signedInDone: "ၶဝ်ႈဢၶွင်ႉယဝ်ႉ။",
    roomWord: "ႁွင်ႈ",
    noteLabel: "မၢႆတွင်း",
  },
  zh: {
    hotelBooking: "Link Stay 预订",
    findStay: "寻找东枝住宿",
    freeRequest: "免费提交申请。酒店确认后到店付款。",
    chooseHotel: "东枝 Link Stay",
    hotelDirectoryHelp: "选择酒店以查看客房、详情和预订选项。",
    from: "起价",
    viewHotel: "查看酒店",
    closeHotel: "关闭酒店详情",
    bookNow: "预订此客房",
    closeLogin: "关闭登录",
    cashHotel: "到店付款",
    request: "申请",
    noCharge: "现在无需付款，酒店需要先确认申请。",
    checkIn: "入住日期",
    checkOut: "退房日期",
    rooms: "房间",
    guests: "客人",
    guestName: "入住人姓名",
    phone: "电话",
    note: "备注（可选）",
    send: "提交预订申请",
    sending: "正在提交…",
    secure: "安全账户",
    create: "创建账户",
    signIn: "登录后继续",
    historyHelp: "预订记录将关联到您验证过的邮箱。",
    name: "姓名",
    email: "电子邮箱",
    password: "密码",
    wait: "请稍候…",
    createButton: "创建账户",
    newHere: "还没有账户？立即创建",
    already: "已有账户？立即登录",
    signOut: "退出登录",
    signedIn: "当前登录",
    checking: "正在检查安全会话…",
    signInFirst: "提交预订申请前请先登录。",
    sent: "申请已提交。酒店确认空房后会与您联系。",
    upTo: "最多",
    myBookings: "我的预订申请",
    noBookings: "您还没有预订申请。",
    operations: "预订管理",
    decisions: "待处理申请",
    confirmAdvice: "确认前请先核实空房。每次操作都会记录。",
    confirm: "确认",
    reject: "拒绝",
    noRequests: "暂无预订申请",
    approvalHelp: "酒店账户获批后，新申请将显示在这里。",
    pending: "待确认",
    confirmed: "已确认",
    rejected: "已拒绝",
    cancelled: "已取消",
    cancelBooking: "取消申请",
    cancellationSaved: "预订申请已取消，并已通知酒店。",
    responseSaved: "回复已保存，并已生成客户通知。",
    accountCreated: "账户已创建。请查看邮件完成验证。",
    signedInDone: "登录成功。",
    roomWord: "间房",
    noteLabel: "备注",
  },
} as const;

type CopyKey = keyof (typeof copy)["en"];
const t = (locale: Locale, key: CopyKey | "checked_in" | "completed") =>
  key === "checked_in"
    ? "Checked in"
    : key === "completed"
      ? "Completed"
      : (copy[locale][key] ?? copy.en[key]);

interface Room {
  id: string;
  property_id: string;
  name: string;
  description: string;
  capacity: number;
  base_price_minor: number;
  currency: string;
}
interface Hotel {
  id: string;
  organization_id: string;
  display_name: string;
  summary: string;
  address: string;
  phone: string;
  hotel_room_types: Room[];
}
interface Booking {
  id: string;
  status: "pending" | "confirmed" | "rejected" | "cancelled" | "checked_in" | "completed";
  check_in: string;
  check_out: string;
  guest_name: string;
  guest_phone: string;
  guest_count: number;
  room_count: number;
  customer_note: string;
  response_note: string;
}

export function AuthPanel({ locale, compact = false }: { locale: Locale; compact?: boolean }) {
  const auth = useAuth();
  const [register, setRegister] = useState(false);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useFeedback();
  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setBusy(true);
    setMessage("");
    const data = new FormData(event.currentTarget);
    const identifier = String(data.get("identifier"));
    const password = String(data.get("password"));
    const error = register
      ? await auth.signUp(
          identifier,
          password,
          String(data.get("name")),
          String(data.get("username")),
        )
      : await auth.signIn(identifier, password);
    setMessage(error ?? (register ? t(locale, "accountCreated") : t(locale, "signedInDone")));
    setBusy(false);
  }
  if (!auth.configured)
    return (
      <div className="notice">
        Account services are currently unavailable. Please try again later.
      </div>
    );
  if (auth.loading) return <div className="notice">{t(locale, "checking")}</div>;
  if (auth.user)
    return (
      <div className="account-bar">
        <span>
          {t(locale, "signedIn")} <strong>{auth.user.email}</strong>
        </span>
        <SignOutButton className="button button--secondary" label={t(locale, "signOut")} />
      </div>
    );
  return (
    <Card className={`auth-card ${compact ? "auth-card--compact" : ""}`}>
      {!compact && (
        <div>
          <p className="eyebrow">{t(locale, "secure")}</p>
          <h3>{register ? t(locale, "create") : t(locale, "signIn")}</h3>
        </div>
      )}
      <form className="form-grid" onSubmit={(e) => void submit(e)}>
        {register && (
          <>
            <label className="field">
              <span>{t(locale, "name")}</span>
              <input name="name" autoComplete="name" minLength={2} required />
            </label>
            <label className="field">
              <span>Username</span>
              <input
                name="username"
                autoComplete="username"
                minLength={3}
                maxLength={30}
                pattern="[A-Za-z0-9_]+"
                required
              />
            </label>
          </>
        )}
        <label className="field">
          <span>{register ? "Email or phone number" : "Email, phone or username"}</span>
          <input
            name="identifier"
            type="text"
            autoComplete={register ? "email" : "username"}
            required
          />
        </label>
        <label className="field">
          <span>{t(locale, "password")}</span>
          <input
            name="password"
            type="password"
            autoComplete={register ? "new-password" : "current-password"}
            minLength={8}
            required
          />
        </label>
        <button className="button" disabled={busy}>
          {busy ? t(locale, "wait") : register ? t(locale, "createButton") : t(locale, "signIn")}
        </button>
      </form>
      <button
        className="text-button"
        onClick={() => {
          setRegister(!register);
          setMessage("");
        }}
      >
        {register ? t(locale, "already") : t(locale, "newHere")}
      </button>
      {message && (
        <p className="form-message" role="status">
          {message}
        </p>
      )}
    </Card>
  );
}

export function CustomerAuthDialog({
  locale,
  onClose,
}: {
  readonly locale: Locale;
  readonly onClose: () => void;
}) {
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [onClose]);

  return (
    <div className="auth-dialog-backdrop" role="presentation" onMouseDown={onClose}>
      <section
        className="auth-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="auth-dialog-title"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <header className="auth-dialog__header">
          <div>
            <p className="eyebrow">{t(locale, "secure")}</p>
            <h2 id="auth-dialog-title">{t(locale, "signIn")}</h2>
          </div>
          <button
            className="service-dialog__close"
            type="button"
            autoFocus
            aria-label={t(locale, "closeLogin")}
            onClick={onClose}
          >
            ×
          </button>
        </header>
        <div className="auth-dialog__content">
          <AuthPanel locale={locale} compact />
        </div>
      </section>
    </div>
  );
}

export function CustomerHotelBooking({
  locale,
  variant = "directory",
  limit,
  searchQuery = "",
  onResultCount,
}: {
  locale: Locale;
  variant?: "directory" | "home";
  limit?: number;
  searchQuery?: string;
  onResultCount?: (count: number) => void;
}) {
  const auth = useAuth();
  const [hotels, setHotels] = useState<Hotel[]>([]);
  const [selectedHotel, setSelectedHotel] = useDetailRecord(hotels);
  const [selected, setSelected] = useState<Room | null>(null);
  const [message, setMessage] = useFeedback();
  const [busy, setBusy] = useState(false);
  const [bookingStarted, setBookingStarted] = useState(false);
  const [loginRequested, setLoginRequested] = useState(false);
  useEffect(() => {
    if (!auth.client) return;
    void Promise.all([
      auth.client
        .from("hotel_properties")
        .select("id,organization_id,display_name,summary,address,phone")
        .eq("is_published", true),
      auth.client
        .from("hotel_room_types")
        .select("id,property_id,name,description,capacity,base_price_minor,currency")
        .eq("is_active", true),
    ]).then(([propertyResult, roomResult]) => {
      const properties = (propertyResult.data ?? []) as Omit<Hotel, "hotel_room_types">[];
      const rooms = (roomResult.data ?? []) as Room[];
      const next = properties.map((property) => ({
        ...property,
        hotel_room_types: rooms.filter((room) => room.property_id === property.id),
      }));
      setHotels(next);
    });
  }, [auth.client]);
  const showBookingForm = bookingStarted || Boolean(auth.user && loginRequested);
  const checkoutRequest = useRef<string | null>(null);
  const checkoutLock = useRef(false);
  async function book(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (!auth.client || !auth.user || !selected) return setMessage(t(locale, "signInFirst"));
    if (checkoutLock.current) return;
    checkoutLock.current = true;
    setBusy(true);
    checkoutRequest.current ??= crypto.randomUUID();
    const d = new FormData(event.currentTarget);
    try {
      const { error } = await submitOrderRequest(
        auth.client,
        "hotel_booking_requests",
        checkoutRequest.current,
        {
          customer_user_id: auth.user.id,
          property_id: selected.property_id,
          room_type_id: selected.id,
          check_in: d.get("check_in"),
          check_out: d.get("check_out"),
          room_count: Number(d.get("room_count")),
          guest_count: Number(d.get("guest_count")),
          guest_name: d.get("guest_name"),
          guest_phone: d.get("guest_phone"),
          customer_note: d.get("note"),
        },
      );
      setMessage(error?.message ?? t(locale, "sent"));
      if (!error) {
        checkoutRequest.current = null;
        setBookingStarted(false);
        setSelected(null);
      }
    } catch (error) {
      setMessage(error instanceof Error ? error.message : "Connection lost. Retry this request.");
    } finally {
      checkoutLock.current = false;
      setBusy(false);
    }
  }

  function openHotel(hotel: Hotel) {
    const firstRoom = hotel.hotel_room_types[0];
    setSelected(firstRoom ?? null);
    setMessage("");
    setBookingStarted(false);
    setLoginRequested(false);
    setSelectedHotel(hotel);
  }

  const normalizedSearch = searchQuery.trim().toLocaleLowerCase();
  const matchingHotels = normalizedSearch
    ? hotels.filter((hotel) =>
        [
          hotel.display_name,
          hotel.summary,
          hotel.address,
          hotel.phone,
          ...hotel.hotel_room_types.flatMap((room) => [room.name, room.description]),
        ]
          .join(" ")
          .toLocaleLowerCase()
          .includes(normalizedSearch),
      )
    : hotels;
  const visibleHotels = typeof limit === "number" ? matchingHotels.slice(0, limit) : matchingHotels;
  useEffect(() => onResultCount?.(matchingHotels.length), [matchingHotels.length, onResultCount]);
  if (normalizedSearch && !matchingHotels.length) return null;

  return (
    <section className={`vertical-feature ${variant === "home" ? "hotel-home-directory" : ""}`}>
      {variant === "directory" && (
        <div className="section-heading">
          <div>
            <h2>{t(locale, "chooseHotel")}</h2>
          </div>
        </div>
      )}
      <div className="hotel-directory-grid" hidden={Boolean(selectedHotel)}>
        <PaginatedList
          layout="cards"
          items={visibleHotels}
          resetKey={normalizedSearch}
          label="Hotel pages"
          renderItem={(hotel, index) => {
            const room = hotel.hotel_room_types[0];
            return (
              <button
                className="hotel-listing-card"
                key={hotel.id}
                type="button"
                aria-haspopup="dialog"
                onClick={() => openHotel(hotel)}
              >
                <HotelArtwork variant={index % 3} />
                <span className="hotel-listing-card__body">
                  <strong>{hotel.display_name}</strong>
                  <small>{hotel.address}</small>
                  <span>{hotel.summary}</span>
                  {room && (
                    <b>
                      {t(locale, "from")} {(room.base_price_minor / 100).toLocaleString()} MMK
                    </b>
                  )}
                  <em>
                    {t(locale, "viewHotel")} <span aria-hidden="true">→</span>
                  </em>
                </span>
              </button>
            );
          }}
        />
      </div>

      {selectedHotel && (
        <div className="provider-detail-page" role="presentation">
          <section
            className="provider-detail-content"
            role="region"
            aria-labelledby="hotel-detail-title"
            onMouseDown={(event) => event.stopPropagation()}
          >
            <div className="hotel-detail-dialog__handle" aria-hidden="true" />
            <header className="hotel-detail-dialog__header">
              <div>
                <p className="eyebrow">{t(locale, "hotelBooking")}</p>
                <h2 id="hotel-detail-title">{selectedHotel.display_name}</h2>
                <p>{selectedHotel.address}</p>
              </div>
              <button
                className="service-dialog__close"
                type="button"
                aria-label={t(locale, "closeHotel")}
                onClick={() => setSelectedHotel(null)}
              >
                ×
              </button>
            </header>
            <div className="hotel-detail-dialog__content">
              <div className="hotel-detail-hero">
                <HotelArtwork variant={Math.max(0, hotels.indexOf(selectedHotel)) % 3} />
                <div>
                  <p className="eyebrow">{t(locale, "findStay")}</p>
                  <h3>{selectedHotel.summary}</h3>
                </div>
              </div>
              <ProviderReputation
                key={selectedHotel.organization_id}
                org={selectedHotel.organization_id}
              />
              <p className="hotel-detail-intro">{t(locale, "freeRequest")}</p>
              <div className="hotel-layout">
                <div className="hotel-list">
                  <PaginatedList
                    layout="cards"
                    items={selectedHotel.hotel_room_types}
                    resetKey={selectedHotel.id}
                    label="Room type pages"
                    renderItem={(room) => (
                      <button
                        className={`hotel-card ${selected?.id === room.id ? "hotel-card--selected" : ""}`}
                        key={room.id}
                        type="button"
                        onClick={() => setSelected(room)}
                      >
                        <span>
                          <strong>{room.name}</strong>
                          <small>{room.description}</small>
                        </span>
                        <span>
                          <strong>{(room.base_price_minor / 100).toLocaleString()} MMK</strong>
                          <small>
                            {t(locale, "upTo")} {room.capacity}
                          </small>
                        </span>
                      </button>
                    )}
                  />
                </div>
                {selected && (
                  <Card className="booking-card">
                    <StatusPill tone="success">{t(locale, "cashHotel")}</StatusPill>
                    <h3>
                      {t(locale, "request")} {selected.name}
                    </h3>
                    <p>{t(locale, "noCharge")}</p>
                    {!showBookingForm && !loginRequested && (
                      <button
                        className="button booking-primary-action"
                        type="button"
                        onClick={() => {
                          if (auth.user) setBookingStarted(true);
                          else setLoginRequested(true);
                        }}
                      >
                        {t(locale, "bookNow")}
                      </button>
                    )}
                    {loginRequested && !auth.user && (
                      <CustomerAuthDialog
                        locale={locale}
                        onClose={() => setLoginRequested(false)}
                      />
                    )}
                    {showBookingForm && (
                      <form className="form-grid form-grid--two" onSubmit={(e) => void book(e)}>
                        <label className="field">
                          <span>{t(locale, "checkIn")}</span>
                          <input name="check_in" type="date" required />
                        </label>
                        <label className="field">
                          <span>{t(locale, "checkOut")}</span>
                          <input name="check_out" type="date" required />
                        </label>
                        <label className="field">
                          <span>{t(locale, "rooms")}</span>
                          <input
                            name="room_count"
                            type="number"
                            min="1"
                            max="10"
                            defaultValue="1"
                            required
                          />
                        </label>
                        <label className="field">
                          <span>{t(locale, "guests")}</span>
                          <input
                            name="guest_count"
                            type="number"
                            min="1"
                            max={selected.capacity * 10}
                            defaultValue="1"
                            required
                          />
                        </label>
                        <label className="field">
                          <span>{t(locale, "guestName")}</span>
                          <input name="guest_name" minLength={2} required />
                        </label>
                        <label className="field">
                          <span>{t(locale, "phone")}</span>
                          <input name="guest_phone" type="tel" minLength={6} required />
                        </label>
                        <label className="field field--wide">
                          <span>{t(locale, "note")}</span>
                          <textarea name="note" rows={3} maxLength={1000} />
                        </label>
                        <button className="button field--wide" disabled={busy}>
                          {busy ? t(locale, "sending") : t(locale, "send")}
                        </button>
                      </form>
                    )}
                    {message && (
                      <p className="form-message" role="status">
                        {message}
                      </p>
                    )}
                  </Card>
                )}
              </div>
            </div>
          </section>
        </div>
      )}
    </section>
  );
}

function HotelArtwork({ variant }: { readonly variant: number }) {
  return (
    <span
      className={`hotel-listing-card__image hotel-listing-card__image--${variant}`}
      aria-hidden="true"
    >
      <span />
      <svg viewBox="0 0 80 64">
        <path d="M15 55V25L40 9l25 16v30M27 55V43h26v12M25 29h8v8h-8zm22 0h8v8h-8z" />
      </svg>
      <i />
    </span>
  );
}

export function HotelBookingInbox({
  locale,
  showHeading = true,
}: {
  locale: Locale;
  showHeading?: boolean;
}) {
  const auth = useAuth();
  const [items, setItems] = useState<Booking[]>([]);
  const [message, setMessage] = useFeedback();
  const [query, setQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState<Booking["status"] | "all">("all");
  const load = useCallback(async () => {
    if (!auth.client || !auth.user) return;
    const { data, error } = await auth.client
      .from("hotel_booking_requests")
      .select(
        "id,status,check_in,check_out,guest_name,guest_phone,guest_count,room_count,customer_note,response_note",
      )
      .order("created_at", { ascending: false });
    if (error) setMessage(error.message);
    else setItems((data ?? []) as Booking[]);
  }, [auth.client, auth.user, setMessage]);
  useOrderRefresh(load);
  useEffect(() => {
    if (!auth.client || !auth.user) return;
    let active = true;
    void auth.client
      .from("hotel_booking_requests")
      .select(
        "id,status,check_in,check_out,guest_name,guest_phone,guest_count,room_count,customer_note,response_note",
      )
      .order("created_at", { ascending: false })
      .then(({ data, error }) => {
        if (!active) return;
        if (error) setMessage(error.message);
        else setItems((data ?? []) as Booking[]);
      });
    return () => {
      active = false;
    };
  }, [auth.client, auth.user, setMessage]);
  async function advanceStay(id: string, next_status: "checked_in" | "completed") {
    if (!auth.client) return;
    const { error } = await auth.client.rpc("update_hotel_stay_status", {
      booking_id: id,
      next_status,
    });
    setMessage(error?.message ?? "Stay updated.");
    await load();
  }
  async function respond(id: string, decision: "confirmed" | "rejected") {
    if (!auth.client) return;
    const { error } = await auth.client.rpc("respond_to_hotel_booking", {
      booking_id: id,
      decision,
      note: "",
    });
    setMessage(error?.message ?? t(locale, "responseSaved"));
    await load();
  }
  const filteredItems = useMemo(() => {
    const normalized = query.trim().toLocaleLowerCase();
    return items.filter(
      (item) =>
        (statusFilter === "all" || item.status === statusFilter) &&
        (!normalized ||
          [item.guest_name, item.guest_phone].some((value) =>
            value.toLocaleLowerCase().includes(normalized),
          )),
    );
  }, [items, query, statusFilter]);
  return (
    <section className="vertical-feature">
      {showHeading && (
        <div className="section-heading">
          <div>
            <h2>{t(locale, "decisions")}</h2>
          </div>
        </div>
      )}
      {!auth.user && <AuthPanel locale={locale} />}
      {auth.user && (
        <div className="filtered-list-stack">
          <ManagementListToolbar
            query={query}
            onQueryChange={setQuery}
            searchLabel="Search guest or phone"
            resultCount={filteredItems.length}
            filters={[
              {
                label: "Status",
                value: statusFilter,
                onChange: (value) => setStatusFilter(value as Booking["status"] | "all"),
                options: [
                  { value: "all", label: "All statuses" },
                  ...(
                    [
                      "pending",
                      "confirmed",
                      "checked_in",
                      "completed",
                      "rejected",
                      "cancelled",
                    ] as const
                  ).map((value) => ({
                    value,
                    label: t(locale, value),
                  })),
                ],
              },
            ]}
            onClear={() => {
              setQuery("");
              setStatusFilter("all");
            }}
          />
          <div className="request-list">
            {filteredItems.length ? (
              <PaginatedList
                items={filteredItems}
                resetKey={`${query}:${statusFilter}`}
                label="Booking request pages"
                renderItem={(item) => (
                  <Card className="request-card" key={item.id}>
                    <div>
                      <StatusPill
                        tone={
                          item.status === "confirmed"
                            ? "success"
                            : item.status === "pending"
                              ? "warning"
                              : "neutral"
                        }
                      >
                        {t(locale, item.status)}
                      </StatusPill>
                      <h3>{item.guest_name}</h3>
                      <p>
                        {formatRecordDate(item.check_in)} → {formatRecordDate(item.check_out)} ·{" "}
                        {item.guest_count} {t(locale, "guests")} · {item.room_count}{" "}
                        {t(locale, "roomWord")}
                      </p>
                      <a href={`tel:${item.guest_phone}`}>{item.guest_phone}</a>
                      {item.customer_note && (
                        <p>
                          {t(locale, "noteLabel")}: {item.customer_note}
                        </p>
                      )}
                    </div>
                    {(item.status === "confirmed" || item.status === "checked_in") && (
                      <button
                        className="button"
                        onClick={() =>
                          void advanceStay(
                            item.id,
                            item.status === "confirmed" ? "checked_in" : "completed",
                          )
                        }
                      >
                        {item.status === "confirmed" ? "Check in guest" : "Check out and complete"}
                      </button>
                    )}
                    {item.status === "pending" && (
                      <div className="request-actions">
                        <button
                          className="button"
                          onClick={() => void respond(item.id, "confirmed")}
                        >
                          {t(locale, "confirm")}
                        </button>
                        <button
                          className="button button--danger"
                          onClick={() => void respond(item.id, "rejected")}
                        >
                          {t(locale, "reject")}
                        </button>
                      </div>
                    )}
                  </Card>
                )}
              />
            ) : (
              <RecordTable
                items={filteredItems}
                rowKey={(item) => item.id}
                label="Bookings"
                empty={t(locale, "noRequests")}
                columns={[
                  { key: "guest", label: "Guest", render: (item) => item.guest_name },
                  { key: "status", label: "Status", render: (item) => item.status },
                ]}
              />
            )}
          </div>
        </div>
      )}
      {message && (
        <p className="form-message" role="status">
          {message}
        </p>
      )}
    </section>
  );
}

interface ManagedProperty {
  id: string;
  display_name: string;
  summary: string;
  address: string;
  phone: string;
  check_in_time: string;
  check_out_time: string;
  is_published: boolean;
}
interface ManagedRoom {
  id: string;
  property_id: string;
  name: string;
  description: string;
  capacity: number;
  base_price_minor: number;
  is_active: boolean;
}
const managementWords = {
  en: {
    eyebrow: "Link Stay setup",
    title: "Property, rooms and availability",
    help: "Complete your profile, add room types, then publish daily inventory.",
    profile: "Property details",
    summary: "Summary",
    address: "Address",
    phone: "Phone",
    checkIn: "Check-in time",
    checkOut: "Check-out time",
    save: "Save property",
    room: "Add room type",
    roomName: "Room name",
    description: "Description",
    capacity: "Guest capacity",
    basePrice: "Base price (MMK)",
    addRoom: "Add room",
    inventory: "Daily availability",
    selectRoom: "Room type",
    start: "Start date",
    end: "End date",
    total: "Available rooms",
    price: "Nightly price (MMK)",
    publish: "Set date range",
    unpublished: "Waiting for Admin publishing approval",
    saved: "Saved successfully.",
  },
  my: {
    eyebrow: "ဟိုတယ်ပြင်ဆင်မှု",
    title: "ဟိုတယ်၊ အခန်းနှင့် ရရှိနိုင်မှု",
    help: "ဟိုတယ်အချက်အလက်ဖြည့်၊ အခန်းအမျိုးအစားထည့်ပြီး နေ့စဉ်ရရှိနိုင်မှု သတ်မှတ်ပါ။",
    profile: "ဟိုတယ်အချက်အလက်",
    summary: "အကျဉ်းချုပ်",
    address: "လိပ်စာ",
    phone: "ဖုန်း",
    checkIn: "တည်းခိုချိန်",
    checkOut: "ထွက်ခွာချိန်",
    save: "သိမ်းမည်",
    room: "အခန်းအမျိုးအစားထည့်ရန်",
    roomName: "အခန်းအမည်",
    description: "ဖော်ပြချက်",
    capacity: "ဧည့်သည်အရေအတွက်",
    basePrice: "အခြေခံစျေး (MMK)",
    addRoom: "အခန်းထည့်မည်",
    inventory: "နေ့စဉ်ရရှိနိုင်မှု",
    selectRoom: "အခန်းအမျိုးအစား",
    start: "စတင်ရက်",
    end: "ပြီးဆုံးရက်",
    total: "ရရှိနိုင်သောအခန်း",
    price: "တစ်ညစျေး (MMK)",
    publish: "ရက်အပိုင်းအခြားသတ်မှတ်မည်",
    unpublished: "Admin ထုတ်ပြန်ခွင့်ကို စောင့်နေသည်",
    saved: "သိမ်းပြီးပါပြီ။",
  },
  shn: {
    eyebrow: "တင်ႈၶႃႈႁူင်းလိုဝ်ႈ",
    title: "ႁူင်းလိုဝ်ႈ ႁွင်ႈ လႄႈတီႈဝ่าง",
    help: "တႅမ်ႈၶေႃႈမုၼ်း သႂ်ႇမဵဝ်းႁွင်ႈ လႄႈတင်ႈတီႈဝ่างၵူႈဝၼ်း။",
    profile: "ၶေႃႈမုၼ်းႁူင်းလိုဝ်ႈ",
    summary: "ၶေႃႈယ่อ",
    address: "တီႈယူႇ",
    phone: "ၾူၼ်း",
    checkIn: "ယၢမ်းၶဝ်ႈ",
    checkOut: "ယၢမ်းဢွၵ်ႇ",
    save: "သိမ်း",
    room: "သႂ်ႇမဵဝ်းႁွင်ႈ",
    roomName: "ၸိုဝ်ႈႁွင်ႈ",
    description: "ၶေႃႈသပ်းလႅင်း",
    capacity: "ၶႅၵ်ႇ",
    basePrice: "ၵႃႈၶၼ် (MMK)",
    addRoom: "သႂ်ႇႁွင်ႈ",
    inventory: "တီႈဝ่างၵူႈဝၼ်း",
    selectRoom: "မဵဝ်းႁွင်ႈ",
    start: "ဝၼ်းတႄႇ",
    end: "ဝၼ်းသုတ်း",
    total: "ႁွင်ႈဝ่าง",
    price: "ၵႃႈၼိုင်ႈၶိုၼ်း",
    publish: "တင်ႈၸူဝ်ႈဝၼ်း",
    unpublished: "ပႂ်ႉ Admin ယိုၼ်ယၼ်",
    saved: "သိမ်းယဝ်ႉ။",
  },
  zh: {
    eyebrow: "酒店设置",
    title: "酒店、房型和房量",
    help: "完善酒店资料、添加房型，然后设置每日房量。",
    profile: "酒店资料",
    summary: "简介",
    address: "地址",
    phone: "电话",
    checkIn: "入住时间",
    checkOut: "退房时间",
    save: "保存酒店资料",
    room: "添加房型",
    roomName: "房型名称",
    description: "说明",
    capacity: "入住人数",
    basePrice: "基础价格（MMK）",
    addRoom: "添加房型",
    inventory: "每日房量",
    selectRoom: "房型",
    start: "开始日期",
    end: "结束日期",
    total: "可用房间",
    price: "每晚价格（MMK）",
    publish: "设置日期范围",
    unpublished: "等待管理员发布批准",
    saved: "保存成功。",
  },
} as const;

export function HotelManagement({ locale }: { locale: Locale }) {
  const auth = useAuth();
  const text = managementWords[locale];
  const [property, setProperty] = useState<ManagedProperty | null>(null);
  const [rooms, setRooms] = useState<ManagedRoom[]>([]);
  const [query, setQuery] = useState("");
  const [status, setStatus] = useState("all");
  const [message, setMessage] = useFeedback();
  const load = useCallback(async () => {
    if (!auth.client || !auth.user) return;
    const { data: membership } = await auth.client
      .from("organization_memberships")
      .select("organization_id")
      .eq("user_id", auth.user.id)
      .eq("role", "hotel_owner")
      .eq("status", "active")
      .limit(1)
      .maybeSingle();
    if (!membership) return;
    const { data: hotel } = await auth.client
      .from("hotel_properties")
      .select("id,display_name,summary,address,phone,check_in_time,check_out_time,is_published")
      .eq("organization_id", membership.organization_id)
      .maybeSingle();
    setProperty((hotel as ManagedProperty | null) ?? null);
    if (hotel) {
      const { data } = await auth.client
        .from("hotel_room_types")
        .select("id,property_id,name,description,capacity,base_price_minor,is_active")
        .eq("property_id", hotel.id)
        .order("created_at");
      setRooms((data ?? []) as ManagedRoom[]);
    }
  }, [auth.client, auth.user]);
  useOrderRefresh(load);
  useEffect(() => {
    if (!auth.client || !auth.user) return;
    let active = true;
    void auth.client
      .from("organization_memberships")
      .select("organization_id")
      .eq("user_id", auth.user.id)
      .eq("role", "hotel_owner")
      .eq("status", "active")
      .limit(1)
      .maybeSingle()
      .then(async ({ data: membership }) => {
        if (!active || !membership) return;
        const { data: hotel } = await auth
          .client!.from("hotel_properties")
          .select("id,display_name,summary,address,phone,check_in_time,check_out_time,is_published")
          .eq("organization_id", membership.organization_id)
          .maybeSingle();
        if (!active) return;
        setProperty((hotel as ManagedProperty | null) ?? null);
        if (hotel) {
          const { data } = await auth
            .client!.from("hotel_room_types")
            .select("id,property_id,name,description,capacity,base_price_minor,is_active")
            .eq("property_id", hotel.id)
            .order("created_at");
          if (active) setRooms((data ?? []) as ManagedRoom[]);
        }
      });
    return () => {
      active = false;
    };
  }, [auth.client, auth.user]);
  async function addRoom(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const form = event.currentTarget;
    if (!auth.client || !property) return;
    const d = new FormData(form);
    const { error } = await auth.client.from("hotel_room_types").insert({
      property_id: property.id,
      name: d.get("name"),
      description: d.get("description"),
      capacity: Number(d.get("capacity")),
      base_price_minor: Math.round(Number(d.get("price")) * 100),
      currency: "MMK",
      is_active: true,
    });
    setMessage(error?.message ?? text.saved);
    if (!error) {
      form.reset();
      form.closest("dialog")?.close();
      await load();
    }
  }
  async function setInventory(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (!auth.client) return;
    const d = new FormData(event.currentTarget);
    const { error } = await auth.client.rpc("set_hotel_inventory_range", {
      target_room_type_id: d.get("room"),
      start_date: d.get("start"),
      end_date: d.get("end"),
      room_total: Number(d.get("total")),
      nightly_price_minor: Math.round(Number(d.get("price")) * 100),
    });
    setMessage(error?.message ?? text.saved);
  }
  const filteredRooms = rooms.filter(
    (r) =>
      (status === "all" || r.is_active === (status === "active")) &&
      `${r.name} ${r.description}`.toLowerCase().includes(query.trim().toLowerCase()),
  );
  if (!auth.user || !property) return null;
  return (
    <section className="hotel-management">
      {!property.is_published && <div className="notice">{text.unpublished}</div>}
      <section className="room-list">
        <CountStrip
          values={[
            ["Active rooms", rooms.filter((r) => r.is_active).length],
            ["Total rooms", rooms.length],
          ]}
        />
        <ManagementListToolbar
          actions={
            <RecordFormDialog title={text.room}>
              <form className="form-grid" onSubmit={(e) => void addRoom(e)}>
                <label className="field">
                  <span>{text.roomName}</span>
                  <input name="name" required />
                </label>
                <label className="field">
                  <span>{text.description}</span>
                  <textarea name="description" rows={2} />
                </label>
                <label className="field">
                  <span>{text.capacity}</span>
                  <input name="capacity" type="number" min="1" max="20" required />
                </label>
                <label className="field">
                  <span>{text.basePrice}</span>
                  <input name="price" type="number" min="0" required />
                </label>
                <button className="button">{text.addRoom}</button>
              </form>
            </RecordFormDialog>
          }
          query={query}
          onQueryChange={setQuery}
          searchLabel="Search room types"
          resultCount={filteredRooms.length}
          filters={[
            {
              label: "Status",
              value: status,
              onChange: setStatus,
              options: [
                { value: "all", label: "All statuses" },
                { value: "active", label: "Active" },
                { value: "inactive", label: "Inactive" },
              ],
            },
          ]}
          onClear={() => {
            setQuery("");
            setStatus("all");
          }}
        />
        <div className="filtered-list-stack">
          <RecordTable
            items={filteredRooms}
            rowKey={(room) => room.id}
            resetKey={query + status}
            label="Room types"
            columns={[
              {
                key: "name",
                label: "Room",
                render: (room) => (
                  <>
                    <strong>{room.name}</strong>
                    <div className="record-table__secondary">{room.description}</div>
                  </>
                ),
              },
              { key: "capacity", label: "Guests", render: (room) => room.capacity },
              {
                key: "price",
                label: "Nightly rate",
                render: (room) => <>{(room.base_price_minor / 100).toLocaleString()} MMK</>,
              },
              {
                key: "status",
                label: "Status",
                render: (room) => (
                  <StatusPill tone={room.is_active ? "success" : "neutral"}>
                    {room.is_active ? "Active" : "Inactive"}
                  </StatusPill>
                ),
              },
              {
                key: "actions",
                label: "Availability",
                render: (room) => (
                  <RecordFormDialog
                    title={`${room.name} — ${text.inventory}`}
                    triggerLabel={`Edit availability for ${room.name}`}
                    action="edit"
                  >
                    <form className="form-grid" onSubmit={(e) => void setInventory(e)}>
                      <input type="hidden" name="room" value={room.id} />
                      <div className="form-grid form-grid--two">
                        <label className="field">
                          <span>{text.start}</span>
                          <input name="start" type="date" required />
                        </label>
                        <label className="field">
                          <span>{text.end}</span>
                          <input name="end" type="date" required />
                        </label>
                      </div>
                      <label className="field">
                        <span>{text.total}</span>
                        <input name="total" type="number" min="0" max="500" required />
                      </label>
                      <label className="field">
                        <span>{text.price}</span>
                        <input name="price" type="number" min="0" required />
                      </label>
                      <button className="button" disabled={!rooms.length}>
                        {text.publish}
                      </button>
                    </form>
                  </RecordFormDialog>
                ),
              },
            ]}
          />
        </div>
        {!filteredRooms.length && <p>No room types match these filters.</p>}
      </section>

      {message && <p className="form-message">{message}</p>}
    </section>
  );
}
